export class CategoryFilterSettingsModel {
  public name: string;
}